export default function FormHeading({ headingText, colSpan = 2 }) {
  console.log(`FormHeading rendered: ${headingText}`)

  return (
    <thead>
      <tr>
        <th colSpan={colSpan} style={{ fontSize: 'large' }}>{headingText}</th>
      </tr>
    </thead>
  )
}
